<template>
<div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3 mr-r15">템플릿 목록</div>
    </div>
    <div class="vertical-center-box" align="right">
      <el-button size="small" class="mr-r4" @click="onClickExportExcel"><img src="@/assets/img/icons/excel.png" style="position:relative;top:3px;left:-2px"> 엑셀출력</el-button>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper ref="table" :column-default="columnDefault" :data="tableData" :columns="tableColumns" :show-search-tool="showSearchTool" :show-custom-header="true" remote pagination :total="total" @condition-change="loadData">
    <template slot-scope="scope" slot="execute-slot">
      <el-button v-if="checkTriggerAuthorized(scope.row.authority)" @click.stop="onClickExecuteButton(scope.row)">수행</el-button>
      <span v-else>{{ EMPTY_TEXT }}</span>
    </template>
  </el-table-wrapper>
  <w-execute-detail-popup ref="detailPopup" :selected-trigger="selectedTrigger"></w-execute-detail-popup>
</div>
</template>

<script>
import { isEqual, isNil } from 'lodash';
import { mapGetters } from 'vuex';
import { getValueAfterCheckEmpty, EMPTY_TEXT } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import { columnDefault } from '@/constants/table';
import AmsExecutionAPI from '@/api/ams/execution';
import FileApi from '@/api/common/file';
import WExecuteDetailPopup from '../popup/ExecuteDetailPopup';
// import msgUtil from '@/utils/message';
const defaultFormatter = (row, column, value) => getValueAfterCheckEmpty(value);

export default {
  name: 'WTriggerListTable',
  components: {
    WExecuteDetailPopup,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    grpFilters: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      EMPTY_TEXT,
      columnDefault,
      total: 0,
      showSearchTool: false,
      tableColumns: [
        {
          prop: 'grpName',
          label: '그룹 명',
          searchable: true,
          formatter: defaultFormatter,
        },
        // { prop: 'triggerId', label: '템플릿 아이디', searchable: true, formatter: defaultFormatter },
        {
          prop: 'triggerName',
          label: '템플릿 명',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'triggerDesc',
          label: '템플릿 설명',
          searchable: true,
          formatter: defaultFormatter,
        },
        {
          prop: 'scheduleExpression',
          label: '스케쥴',
          // searchable: true,
          formatter: this.setPeriodSettingDataByCronExpression,
        },
        {
          prop: 'lastDatetime',
          label: '마지막 수행 일시',
          width: '140px',
          formatter: this.getDateFormatter,
        },
        {
          prop: 'nextScheduledTime',
          label: '다음 수행 일시',
          width: '140px',
          formatter: this.getDateFormatter,
        },
        {
          prop: 'createDatetime',
          label: '생성일시',
          width: '140px',
          formatter: this.getDateFormatter,
        },
        {
          scopedSlot: 'execute-slot',
          label: '수행',
          width: '70px',
        },
      ],
      tableData: [],
      checkedRows: [],
      selectedTrigger: null,
    };
  },
  computed: {
    ...mapGetters(['userInfo']),
  },
  watch: {
    active(flag) {
      if (flag) {
        this.loadData();
      }
    },
    grpFilters() {
      this.loadData();
    },
  },
  methods: {
    loadData() {
      const tableParams = this.$refs.table.getParameter();
      const params = {
        ...tableParams,
        grpFilters: this.grpFilters,
      };
      AmsExecutionAPI.getTriggerList(params).then((response) => {
        const result = response.data;
        if (result.success) {
          this.total = result.total;
          this.tableData = result.data;
        }
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    onClickExecuteButton(row) {
      this.selectedTrigger = row;
      this.$refs.detailPopup.open();
    },
    setPeriodSettingDataByCronExpression(row, column, value) {
      const scheduleApplyFlag = row.scheduleApplyFlag;
      if (isEqual(scheduleApplyFlag, 'Y')) {
        const cronExpression = value;
        const cron = cronExpression.split(' ');
        const minutes = this.pad(cron[1], 2);
        const hours = this.pad(cron[2], 2);
        const dayOfMonth = cron[3];
        const month = cron[4];
        const dayOfWeek = cron[5];
        const year = cron[6];
        let period = 'N';

        if (dayOfMonth.indexOf('*') > -1) {
          period = 'D';
        } else if (month.indexOf('*') > -1) {
          period = 'W';
        } else if (year.indexOf('*') > -1) {
          period = 'M';
        }

        let resultText = null;
        if (period === 'N') {
          resultText = `${year}-${month}-${dayOfMonth} ${hours}:${minutes} 한번`;
        } else if (period === 'D') {
          resultText = `매일 ${hours}:${minutes}`;
        } else if (period === 'W') {
          const weekObject = {
            1: '일',
            2: '월',
            3: '화',
            4: '수',
            5: '목',
            6: '금',
            7: '토',
          };
          const dayOfWeekArr = dayOfWeek.split(',');
          let dayOfWeekStr = null;
          dayOfWeekArr.forEach((num) => {
            if (isNil(dayOfWeekStr)) {
              dayOfWeekStr = weekObject[num];
            } else {
              dayOfWeekStr += `,${weekObject[num]}`;
            }
          });
          resultText = `매주 ${dayOfWeekStr} ${hours}:${minutes}`;
        } else if (period === 'M') {
          this.monthlyData = {
            scheduleIntervalMonth: month.split('/')[1],
            scheduleIntervalDate: dayOfMonth,
            scheduleHour: Number(hours),
            scheduleMinute: Number(minutes),
          };
          resultText = `1월부터 ${month.split('/')[1]}개월마다 ${dayOfMonth === 'L' ? '말' : dayOfMonth}일 ${hours}:${minutes}`;
        }
        return resultText;
      }
      return EMPTY_TEXT;
    },
    pad(n, width) {
      return n.length >= width ? n : `0${n}`;
    },
    /**
     * 엑셀출력 버튼 click
     * @author jeee12
     * @return {[type]} [description]
     */
    onClickExportExcel() {
      const tableParams = this.$refs.table.getParameter();
      const params = {
        ...tableParams,
        grpFilters: this.grpFilters,
      };
      AmsExecutionAPI.exportTriggerListExcel(params).then((response) => {
        if (response.data.success && response.data.data) {
          FileApi.downloadExportedExcelFile(response.data.data);
        }
      }).catch(() => {});
    },
    /**
     * 로그인한 계정 기준 템플릿 수행권한 체크
     * @author jeee12
     * @param  {[type]} authority [description]
     * @return {[type]}           [description]
     */
    checkTriggerAuthorized(authority) {
      const managerType = this.userInfo.managerType;
      if (managerType === 'ADMIN') {
        return true;
      } else if (managerType === 'MANAGER') {
        return authority === 'SDUSER' || authority === 'MANAGER';
      }
      return authority === 'SDUSER';
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/work/popup/components/ExecuteTrigger/components/TriggerListTable.vue